import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import {
    boolean_medprofregistration,
    OMH_Registration_Data
} from '../../../models/medicalproffessional';
import { CountriesService } from '../../../services/countries.service';
import { Router } from '@angular/router';
import { DoctorsService } from '../../../services/doctors.service';
import { SelectItem, ConfirmationService, MessageService } from 'primeng/api';
import { DaterenderService } from '../../../services/daterender.service';
import {
    PromiseResult,
    ErrorModel,
    ServerError,
    ApiResult
} from '../../../models/PromiseResult';
import { HttpErrorResponse } from '@angular/common/http';
import {
    address,
    blockSpecialCharachters,
    city,
    DOCUMENT_SUPPORTED_TYPES,
    dose_input,
    GOOGLE_RECAPTCHA_SITE_KEY,
    IMAGE_PROFILE_ID_SUPPORTED_TYPES,
    name_input,
    number_input,
    occupation_name_input,
    OTHER_MEDICAL_OCCUPATIONS,
    phoneNumber,
    RESUME_SUPPORTED_TYPES,
    textareaBox,
    USER_TYPES,
    zipCode
} from './../../../constant/constant';
import { OthermedicalregistrationService } from '../../../services/othermedicalregistration.service';
import { DoctorRegistrationCheckerService } from 'src/app/services/doctor-registration-checker.service';
import { UserTypes } from 'src/app/models/User';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { TraceClassDecorator } from '@sentry/angular';
import { Form_Data } from 'src/app/models/util.models';
import { OtpInputComponent } from '../otp-input/otp-input.component';
import { DoctorReferralService } from 'src/app/services/doctor-referral.service';
import { UserService } from '../../../services/user.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';

export class School {
    si_no: string;
    name: string;
    year: string;
}
export class College {
    si_no: string;
    name: string;
    year: string;
}
export class Certifications {
    si_no: string;
    name: string;
}
export class Hospitals {
    si_no: string;
    name: string;
}

class LanguageSpoken {
    english_name: string;
    id: number;
    language_name: string;
    label: string;
}
@Component({
    selector: 'app-medical-proffessional-registration',
    templateUrl: './medical-proffessional-registration.component.html',
    styleUrls: [
        './medical-proffessional-registration.component.css',
        '../../../../assets/css/custom-egd.css'
    ],
    providers: [
        ConfirmationService,
        MessageService
    ]
})
@TraceClassDecorator()
export class MedicalProffessionalRegistrationComponent implements OnInit {

    @ViewChild(OtpInputComponent) OTP_Input: OtpInputComponent;

    readonly name_input: RegExp = name_input;
    readonly address: RegExp = address;
    readonly city_input: RegExp = city;
    readonly phoneNumber: RegExp = phoneNumber;
    readonly zipCode: RegExp = zipCode;
    readonly textarea: RegExp = textareaBox;
    readonly dose_input: RegExp = dose_input;
    readonly number_input: RegExp = number_input;
    readonly blockSpecialCharachters: RegExp = blockSpecialCharachters;
    readonly occupation_input: RegExp = occupation_name_input;
    readonly sitekey: string = GOOGLE_RECAPTCHA_SITE_KEY;
    readonly occupations_list = OTHER_MEDICAL_OCCUPATIONS;
    readonly user_types: UserTypes = USER_TYPES;
    provider_id: string = "";
    showForm = true;
    token_verified: boolean = false;
    School: School[] = [];
    College: College[] = [];
    Certifications: Certifications[] = [];
    Hospitals: Hospitals[] = [];
    slug: string = "";
    years: SelectItem[] = [];
    addedOccupation: string = '';
    year = new Date().getFullYear();
    // occupation: SelectItem[] = [];
    occupations: SelectItem[] = [];
    // poccupations: PrimaryOccupation[];
    selectedpoccupation: string;
    selectedoccupations: string[] = [];
    // soccupations: SecondaryOccupation[];

    selectedsoccupation: string;

    other_primary_occupation: string;
    other_secondary_occupation: string;

    selectedCountry = null;
    countries: any = [];
    unformattedStates: any[];
    phone: any = [];
    selectedState = null;
    StatesToPractice_selectedState = null;
    selectedStateToPratice = null;
    primary_contact_number: string = '';
    secondary_contact_number: string = '';
    selectedPhoneCode_primary: string = '';
    selectedPhoneCode_secondary: string = '';
    token_string: string = null;
    temp = [];
    agree: boolean = false;
    patient_guid: any;
    states: any[];
    dateTime = new Date();
    // profilePhoto: File = null;
    // resume: File = null;
    // profile_data_result: boolean = false;
    // profile_photo_result: boolean = false;
    // resume_result: boolean = false;
    // success_register_display: boolean = false;
    otherreg: OMH_Registration_Data = this.doctorRegistrationCheckerService.otherMedicaldProfRegistration_init();
    License_no = '';
    national_license_no: string = '';
    // posting: boolean;
    languages: LanguageSpoken[] = [];
    selected_language = [];
    national_license: boolean = false;
    // recaptcha_Reset: boolean = false;
    // error: ErrorModel;
    // serverError: ServerError;
    // response: PromiseResult;
    name = '';
    year_of_graduation = null;
    confirmDialogVisible1: boolean = false;
    confirmDialogVisible2: boolean = false;
    confirmDialogVisible3: boolean = false;
    confirmDialogVisible4: boolean = false;
    School_edit_id = -1;
    temp_School_name = '';
    temp_School_year = null;

    College_edit_id = -1;
    temp_College_name = '';
    temp_College_year = null;

    certifications_name = '';
    Certifications_edit_id = -1;
    temp_certifications_name = '';
    edited_certifications_name = '';

    hospitals_name = '';
    hospitals_edit_id = -1;
    temp_hospitals_name = '';
    edited_hospitals_name = '';

    noteDialog: boolean = true;
    othersPrimary_boolean: boolean = false;
    othersSecondary_boolean: boolean = false;

    // error_message_result: PromiseResult;

    image_types: string[] = IMAGE_PROFILE_ID_SUPPORTED_TYPES;
    resume_types: string[] = RESUME_SUPPORTED_TYPES;
    document_types: string[] = DOCUMENT_SUPPORTED_TYPES;

    otherreg_boolean: boolean_medprofregistration =
        this.doctorRegistrationCheckerService.boolean_medprofregistration_init();

    //password changes

    // isPassword: boolean = true;
    // password = "";
    // confirmPassword = '';
    // tipsshowed: boolean = false;






    // StatesToPractice:  statestopractice[];
    constructor(
        private readonly countryService: CountriesService,
        private readonly doctorsservice: DoctorsService,
        private readonly otherMedicalRegistrationService: OthermedicalregistrationService,
        private readonly router: Router,
        private readonly messageService: MessageService,
        private readonly confirmationService: ConfirmationService,
        private readonly daterenderService: DaterenderService,
        private readonly doctorRegistrationCheckerService: DoctorRegistrationCheckerService,
        private readonly utilitiesService: UtilitiesService,
        private readonly changeDetector: ChangeDetectorRef,
        private readonly referralService: DoctorReferralService,
        private readonly user: UserService,
        private readonly providerStateService: ProviderStateService
    ) {
        // this.poccupations = [
        //   { name: 'Nurse Practitioner' },
        //   { name: 'Physician Assistant' },
        //   { name: 'Nurse' },
        //   { name: 'Physical Therapist' },
        //   { name: 'Occupational Therapist' },
        //   { name: 'Respiratory Therapist' },
        //   { name: 'Others' }
        // ];
        // this.soccupations = [
        //   { name: 'Nurse Practitioner' },
        //   { name: 'Physician Assistant' },
        //   { name: 'Nurse' },
        //   { name: 'Physical Therapist' },
        //   { name: 'Occupational Therapist' },
        //   { name: 'Respiratory Therapist' },
        //   { name: 'Others' }
        // ];
        // let tempOccupationsList = Array.from(new Set(this.occupations_list)).sort();
        for (let i = 0; i < this.occupations_list.length; i++) {
            this.occupations.push({
                label: this.occupations_list[i].toString(),
                value: this.occupations_list[i].toString()
            });
        }
    }

    async ngOnInit() {
        // this.response = {
        //     success: null,
        //     error: null,
        //     data: null
        // };
        // this.serverError = {
        //     statusCode: null,
        //     error: null,
        //     message: null
        // };
        this.slug = this.providerStateService.getProviderSlug();
        this.provider_id = this.providerStateService.getProviderId();
        for (let i = 1900; i <= this.year; i++) {
            this.years.push({ label: i.toString(), value: i.toString() });
        }

        this.years.reverse();



        this.dateTime.setDate(this.dateTime.getDate());
        this.dateTime.setFullYear(this.dateTime.getFullYear() - 18);
        this.otherreg = this.doctorRegistrationCheckerService.otherMedicaldProfRegistration_init();

        this.otherreg_boolean =
            this.doctorRegistrationCheckerService.boolean_medprofregistration_init();
        // await this.recaptchaReset();
        await this.getLanguages();
        await this.getCountries();
        // await this.recaptchaReset();
        await this.fetchSources();
        this.otherreg.other_data.recaptchaData.reset();

        this.School = [];
        this.College = [];
        this.Hospitals = [];
        this.Certifications = [];
        this.noteDialog = true;
    }
    private async fetchSources() {
        await this.user.fetchSources().toPromise().then(result => {
            this.otherreg.other_data.user_source = result.map(src => {
                return {
                    label: src.user_source,
                    value: src.user_source_id
                }
            })
        })
    }
    displaySchool: boolean = false;
    editdisplaySchool: boolean = false;
    displayCollege: boolean = false;
    editdisplayCollege: boolean = false;
    displayCertifications: boolean = false;
    displayAffiliatedHospitals: boolean = false;

    showAddSchoolDialog() {
        this.displaySchool = true;
    }
    showAddCollegeDialog() {
        this.displayCollege = true;
    }
    showAddCertificationsDialog() {
        this.displayCertifications = true;
    }
    showAddAffiliatedHospitalsDialog() {
        this.displayAffiliatedHospitals = true;
    }

    getBoolean(a, b): boolean {
        return a === b;
    }

    // showDialog() {
    //     this.success_register_display = true;
    // }

    close() {
        this.displaySchool = false;
        this.displayCollege = false;
        this.displayCertifications = false;
        this.displayAffiliatedHospitals = false;
        this.resetDialog();
    }

    resetDialog() {
        this.name = '';
        this.year_of_graduation = null;
        this.License_no = '';

        this.hospitals_name = '';
        this.year_of_graduation = null;
        this.certifications_name = '';

        this.temp_School_name = '';
        this.temp_School_year = null;

        this.temp_College_name = '';
        this.temp_College_year = null;

        this.edited_certifications_name = '';
        this.temp_certifications_name = '';

        this.edited_hospitals_name = '';
        this.temp_hospitals_name = '';
    }

    addSchool() {
        this.School.push({
            si_no: (this.School.length + 1).toString(),
            name: this.name,
            year: this.year_of_graduation.toString()
        });
        this.name = '';
        this.year_of_graduation = null;
    }
    addCollege() {
        this.College.push({
            si_no: (this.College.length + 1).toString(),
            name: this.name,
            year: this.year_of_graduation.toString()
        });
        this.name = '';
        this.year_of_graduation = null;
    }
    addCertifications() {
        this.Certifications.push({
            si_no: (this.Certifications.length + 1).toString(),
            name: this.certifications_name
        });
        this.certifications_name = '';
    }
    addAffiliatedHospitals() {
        this.Hospitals.push({
            si_no: (this.Hospitals.length + 1).toString(),
            name: this.hospitals_name
        });
        this.hospitals_name = '';
    }

    deleteSchool(row) {
        let temp: School[] = [];
        let j;
        for (let i = 0; i < this.School.length; i++) {
            if (
                this.School[i].name != row.name &&
                this.School[i].year != row.year
            ) {
                temp.push(this.School[i]);
            } else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.School.length; i++) {
            temp.push({
                si_no: (temp.length + 1).toString(),
                name: this.School[i].name,
                year: this.School[i].year
            });
        }
        this.School = temp;
        this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Deleted Successfully'
        });
    }

    deleteCollege(row) {
        let temp: College[] = [];
        let j;
        for (let i = 0; i < this.College.length; i++) {
            if (
                this.College[i].name != row.name &&
                this.College[i].year != row.year
            ) {
                temp.push(this.College[i]);
            } else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.College.length; i++) {
            temp.push({
                si_no: (temp.length + 1).toString(),
                name: this.College[i].name,
                year: this.College[i].year
            });
        }
        this.College = temp;
        this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Deleted Successfully'
        });
    }

    deleteCertifications(row) {
        let temp: Certifications[] = [];
        let j;
        for (let i = 0; i < this.Certifications.length; i++) {
            if (this.Certifications[i].name != row.name) {
                temp.push(this.Certifications[i]);
            } else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.Certifications.length; i++) {
            temp.push({
                si_no: (temp.length + 1).toString(),
                name: this.Certifications[i].name
            });
        }
        this.Certifications = temp;
        this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Deleted Successfully'
        });
    }

    deleteAffiliatedHospitals(row) {
        let temp: Hospitals[] = [];
        let j;
        for (let i = 0; i < this.Hospitals.length; i++) {
            if (this.Hospitals[i].name != row.name) {
                temp.push(this.Hospitals[i]);
            } else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.Hospitals.length; i++) {
            temp.push({
                si_no: (temp.length + 1).toString(),
                name: this.Hospitals[i].name
            });
        }
        this.Hospitals = temp;
        this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Deleted Successfully'
        });
    }

    canceleditData(id, form: string) {
        if (form == 'School') {
            this.School_edit_id = -1;
            this.School[id - 1].name = this.temp_School_name;
            this.School[id - 1].year = this.temp_School_year;
            this.editdisplaySchool = false;
            this.name = '';
            this.year_of_graduation = null;
            this.temp_School_name = '';
            this.temp_School_year = null;
        } else if (form == 'College') {
            this.College_edit_id = -1;
            this.College[id - 1].name = this.temp_College_name;
            this.College[id - 1].year = this.temp_College_year;
            this.editdisplayCollege = false;
            this.name = '';
            this.year_of_graduation = null;
            this.temp_College_name = '';
            this.temp_College_year = null;
        } else if (form == 'Certifications') {
            this.Certifications_edit_id = -1;
            this.Certifications[id - 1].name = this.temp_certifications_name;
            this.edited_certifications_name = '';
            this.temp_certifications_name = '';
        } else if (form == 'Hospitals') {
            this.hospitals_edit_id = -1;
            this.Hospitals[id - 1].name = this.temp_hospitals_name;
            this.edited_hospitals_name = '';
            this.temp_hospitals_name = '';
        }
    }

    saveData(id, form: string) {
        if (form == 'School') {
            this.School[id - 1].name = this.name;
            this.School[id - 1].year = this.year_of_graduation;
            this.School_edit_id = -1;
            this.name = '';
            this.year_of_graduation = null;
            this.editdisplaySchool = false;
            this.temp_School_name = '';
            this.temp_School_year = null;
        } else if (form == 'College') {
            this.College[id - 1].name = this.name;
            this.College[id - 1].year = this.year_of_graduation;
            this.College_edit_id = -1;
            this.name = '';
            this.year_of_graduation = null;
            this.editdisplayCollege = false;
            this.temp_College_name = '';
            this.temp_College_year = null;
        } else if (form == 'Certifications') {
            this.Certifications[id - 1].name = this.edited_certifications_name;
            this.Certifications_edit_id = -1;
            this.edited_certifications_name = '';
            this.temp_certifications_name = '';
        } else if (form == 'Hospitals') {
            this.Hospitals[id - 1].name = this.edited_hospitals_name;
            this.hospitals_edit_id = -1;
            this.edited_hospitals_name = '';
            this.temp_hospitals_name = '';
        }
    }

    editData(id, form: string) {
        if (form == 'School') {
            this.School_edit_id = id;
            this.temp_School_name = this.School[id - 1].name;
            this.temp_School_year = this.School[id - 1].year;
            this.name = this.temp_School_name;
            this.year_of_graduation = this.temp_School_year.toString();
            this.editdisplaySchool = true;
        } else if (form == 'College') {
            this.College_edit_id = id;
            this.temp_College_name = this.College[id - 1].name;
            this.temp_College_year = this.College[id - 1].year;
            this.name = this.temp_College_name;
            this.year_of_graduation = this.temp_College_year.toString();
            this.editdisplayCollege = true;
        } else if (form == 'Certifications') {
            this.Certifications_edit_id = id;
            this.temp_certifications_name = this.Certifications[id - 1].name;
            this.edited_certifications_name = this.temp_certifications_name;
        } else if (form == 'Hospitals') {
            this.hospitals_edit_id = id;
            this.temp_hospitals_name = this.Hospitals[id - 1].name;
            this.edited_hospitals_name = this.temp_hospitals_name;
        }
    }

    confirmSchoolSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-School',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteSchool(product);
            }
        });
    }

    confirmCollegeSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-College',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteCollege(product);
            }
        });
    }

    confirmCertificationsSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-certifications',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteCertifications(product);
            }
        });
    }

    confirmAffiliatedHospitalsSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-affiliatedhospitals',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteAffiliatedHospitals(product);
            }
        });
    }

    async changeStates() {
        this.unformattedStates = [];
        this.states = [];
        this.temp = [];
        this.phone = [];
        this.selectedState = null;
        this.selectedStateToPratice = null;
        this.national_license = this.selectedCountry.is_national_license;
        this.national_license_no = '';
        await this.getStates(this.selectedCountry.id);
        if (this.unformattedStates.length > 0) {
            // this.statesInput=false;

            for (let i = 0; i < this.unformattedStates.length; i++) {
                this.temp.push({
                    state_name: this.unformattedStates[i].state_name,
                    state_id: this.unformattedStates[i].id
                });
            }
            this.states = this.temp;
        } else {
            // this.statesInput=true;
            // this.statesInputDisabled=false;
        }

        this.selectedPhoneCode_primary = "+" + this.selectedCountry.phone_code;
        this.selectedPhoneCode_secondary = "+" + this.selectedCountry.phone_code;
    }

    private async getLanguages() {
        await this.doctorsservice
            .GetLanguageSpoken()
            .toPromise()
            .then((result) => {
                if (result.success) {
                    let temp_languages: LanguageSpoken[] = [];
                    for (let i = 0; i < result.data.length; i++) {
                        let temp: LanguageSpoken = {
                            id: result.data[i].id,
                            language_name: result.data[i].language_name,
                            english_name: result.data[i].english_name,
                            label:
                                result.data[i].english_name +
                                '(' +
                                result.data[i].language_name +
                                ')'
                        };
                        temp_languages.push(temp);
                    }
                    this.languages = temp_languages;
                }
            }).catch(error => console.log(error));
    }

    private async getCountries() {
        await this.countryService
            .getCountries(this.provider_id)
            .toPromise()
            .then((countries) => (this.countries = countries))
            .catch(error => console.log(error));
    }
    async getStates(country_id: number) {
        await this.countryService
            .getStates(country_id)
            .toPromise()
            .then((states) => (this.unformattedStates = states))
            .catch(error => console.log(error));
    }
    uploadProfileFiles(file: File[]) {
        if (this.image_types.includes(file[0].type.toLowerCase())) {
            if (file[0].size > 5033165) {
                // this.fileu=true;
                this.otherreg.api_data.avatar = null;
            } else if (file[0].size < 5033165) {
                // this.fileu=false;
                this.otherreg.api_data.avatar = file[0];
            }
        }
        else {
            this.otherreg.api_data.avatar = null;
        }
    }

    onRemovePhoto() {
        this.otherreg.api_data.avatar = null;
    }

    uploadResumeFiles(file: File[]) {
        if (this.resume_types.includes(file[0].type.toLowerCase())) {
            // this.resume = file[0];
            if (file[0].size > 5033165) {
                // this.fileu=true;
                this.otherreg.api_data.resume = null;
            } else if (file[0].size < 5033165) {
                // this.fileu=false;
                this.otherreg.api_data.resume = file[0];
            }
        }
        else {
            this.otherreg.api_data.resume = null;
        }
    }

    onRemoveResume() {
        this.otherreg.api_data.resume = null;
    }
    // async recaptchaReset() {
    //     this.recaptcha_Reset = false;
    //     setTimeout(() => {
    //         this.recaptcha_Reset = true;
    //     }, 1000);
    // }

    resolved(captchaResponse: string) {
        this.otherreg.api_data.recaptcha = captchaResponse;
    }

    RouterNavigation(path: string) {
        this.router.navigate(['/' + this.slug + '/' + path]);
    }

    gotohome() {
        this.RouterNavigation('/');
    }

    isPosting() {
        return this.otherreg.other_data.reg_api_result.Posting ||
            this.otherreg.other_data.otp_data.otp_api_result.Posting;
    }

    async register_validate_or_resend_otp() {
        this.otherreg.other_data.otp_data.otp_api_result = new ApiResult(true);
        await this.referralService
            .register_doctor_validate_or_resend_otp(this.otherreg.other_data.otp_data.OTP_validate_api)
            .toPromise()
            .then(async (result) => {
                this.otherreg.other_data.otp_data.otp_api_result.PromiseResult = result;
                if (result.success) {
                    if (this.otherreg.other_data.otp_data.OTP_validate_api.retry) {
                        this.set_data(result);
                        this.changeDetector.detectChanges();
                        this.OTP_Input.init_countdown();
                    }
                    else {
                        this.utilitiesService.RouterNavigation(
                            '/user/thank-you/' + this.user_types['OTHER-MEDICAL-PROFESSIONALS']
                        );
                    }
                }
                this.otherreg.other_data.otp_data.otp_api_result.Posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.otherreg.other_data.otp_data.otp_api_result.ServerError = error.error;
                this.otherreg.other_data.otp_data.otp_api_result.PromiseResult.success = false;
                this.otherreg.other_data.otp_data.otp_api_result.Posting = false;
            })
    }

    async otpVerifySubmit() {
        this.otherreg.other_data.otp_data.OTP_validate_api.retry = false;
        await this.register_validate_or_resend_otp();
    }

    async otp_resend() {
        this.otherreg.other_data.otp_data.OTP_validate_api.retry = true;
        await this.register_validate_or_resend_otp();
    }

    set_data(result: PromiseResult) {
        this.otherreg.other_data.otp_data.OTP_validate_api.user_guid = result.data.user_guid;
        this.otherreg.other_data.otp_data.OTP_validate_api.service_id = result.data.service_id;
        this.otherreg.other_data.otp_data.OTP_validate_api.retry_after = new Date(result.data.retry_after);
    }

    // async submitOtherRegistration(){
    //   let waitSec=Number((Math.floor(Math.random() * 1000) + 1)%3);
    //   this.posting=true;
    //   await  setTimeout(async () => {
    //       this.submitData();
    //   }, 5000+waitSec);
    // }

    onAgreeChange(Event: Event) {
        this.agree = Boolean(Event);
    }

    async addNewOccupation() {
        const temp: SelectItem[] = this.occupations;

        let tempaddedOccupation = this.addedOccupation
            .trim()
            .toLowerCase()
            .split(' ');
        for (let i = 0; i < tempaddedOccupation.length; i++) {
            tempaddedOccupation[i] =
                tempaddedOccupation[i][0].toUpperCase() +
                tempaddedOccupation[i].slice(1);
        }
        let b = tempaddedOccupation.join(' ');
        //  code for /

        let tempOccupationsName: string[] = [];
        for (let i = 0; i < temp.length; i++) {
            tempOccupationsName.push(temp[i].label);
        }
        tempOccupationsName.push(b);
        // this.selectedoccupations.push(b.toString());

        let tempOccupations = Array.from(new Set(tempOccupationsName)).sort();
        let temp1: SelectItem[] = [];
        for (let i = 0; i < tempOccupations.length; i++) {
            temp1.push({
                label: tempOccupations[i].toString(),
                value: tempOccupations[i].toString()
            });
        }
        this.occupations = temp1;
        this.addedOccupation = '';
    }

    async submitData(): Promise<void> {
        // await this.recaptchaReset();
        // await this.ResetResultModels();
        // this.posting = true;
        if (this.otherreg.api_data.date_of_birth_date == null) {
            this.otherreg.api_data.date_of_birth = null;
        } else if (this.otherreg.api_data.date_of_birth_date != null) {
            this.otherreg.api_data.date_of_birth = this.daterenderService.render_data(
                this.otherreg.api_data.date_of_birth_date
            );
        }

        if (this.selectedCountry == null) {
            this.otherreg.api_data.country_id = null;
        } else if (this.selectedCountry != null) {
            this.otherreg.api_data.country_id = Number(this.selectedCountry.id);
        }

        if (this.selectedState == null) {
            this.otherreg.api_data.state_name = null;
        } else if (this.selectedState != null) {
            this.otherreg.api_data.state_name = this.selectedState.state_name;
        }

        if (this.selectedpoccupation == null) {
            this.otherreg.api_data.primary_occupation = null;
        } else if (this.selectedpoccupation != null) {
            this.othersPrimary_boolean = false;
            if (
                this.getBoolean(
                    this.selectedpoccupation?.toLowerCase(),
                    'others'
                )
            ) {
                if (this.other_primary_occupation?.length > 0) {
                    this.otherreg.api_data.primary_occupation =
                        this.other_primary_occupation;
                } else {
                    this.otherreg.api_data.primary_occupation = '';
                    this.othersPrimary_boolean = true;
                }
            } else if (
                !this.getBoolean(
                    this.selectedpoccupation?.toLowerCase(),
                    'others'
                )
            ) {
                this.otherreg.api_data.primary_occupation = this.selectedpoccupation;
            }
        }

        if (this.selectedsoccupation == null) {
            this.otherreg.api_data.secondary_occupation = null;
        } else if (this.selectedsoccupation != null) {
            this.othersSecondary_boolean = false;
            if (
                this.getBoolean(
                    this.selectedsoccupation?.toLowerCase(),
                    'others'
                )
            ) {
                if (this.other_secondary_occupation?.length > 0) {
                    this.otherreg.api_data.secondary_occupation =
                        this.other_secondary_occupation;
                } else {
                    this.otherreg.api_data.secondary_occupation = '';
                    this.othersSecondary_boolean = true;
                }
            } else if (
                !this.getBoolean(
                    this.selectedsoccupation?.toLowerCase(),
                    'others'
                )
            ) {
                this.otherreg.api_data.secondary_occupation = this.selectedsoccupation;
            }
        }

        let tempselectedLanguageSpoken: number[] = [];
        if (this.selected_language.length > 0) {
            for (let i = 0; i < this.selected_language?.length; i++) {
                tempselectedLanguageSpoken.push(
                    Number(this.selected_language[i].id)
                );
            }
        }

        this.otherreg.api_data.language_id = tempselectedLanguageSpoken;

        // this.otherreg.api_data.date_of_birth = this.daterenderService.render_data(this.otherreg.api_data.date_of_birth);
        // this.otherreg.api_data.country_id = this.selectedCountry.id;
        if (this.otherreg.api_data.years_of_experience == null) {
            this.otherreg.api_data.years_of_experience = null;
        } else if (this.otherreg.api_data.years_of_experience != null) {
            this.otherreg.api_data.years_of_experience = Number(
                this.otherreg.api_data.years_of_experience
            );
        }

        // this.otherreg.api_data.state_name = this.selectedState.state_name;
        // }

        this.otherreg.api_data.education = this.School;

        let tempCertifications: string[] = [];
        for (let i = 0; i < this.Certifications.length; i++) {
            //  this.otherreg.api_data.board_certification.push(this.Board[i].name)
            tempCertifications.push(this.Certifications[i].name);
        }
        this.otherreg.api_data.certifications = tempCertifications;

        let tempAffiliatedHospitals: string[] = [];
        for (let i = 0; i < this.Hospitals.length; i++) {
            //  this.otherreg.api_data.board_certification.push(this.Board[i].name)
            tempAffiliatedHospitals.push(this.Hospitals[i].name);
        }
        this.otherreg.api_data.affiliated_hospitals = tempAffiliatedHospitals;

        if (this.primary_contact_number?.length > 0) {
            this.otherreg.api_data.primary_contact_number =
                this.selectedPhoneCode_primary +
                this.primary_contact_number.slice(-10);
        }
        if (this.secondary_contact_number?.length > 0) {
            this.otherreg.api_data.secondary_contact_number =
                this.selectedPhoneCode_secondary +
                this.secondary_contact_number.slice(-10);
        }

        // this.otherreg.api_data.license_number = "license";
        this.otherreg.api_data.token = this.token_string;

        this.otherreg_boolean =
            await this.doctorRegistrationCheckerService
                .OtherMedicalFormSubmitChecker(
                    this.otherreg.api_data,
                    false,
                    this.otherreg.api_data.avatar,
                    this.agree
                );
        this.otherreg.other_data.form_error_message_result.PromiseResult =
            await this.doctorRegistrationCheckerService
                .getOtherMedicalRegFormErrors(
                    this.otherreg_boolean
                );
        if (this.othersPrimary_boolean || this.othersSecondary_boolean) {
            this.otherreg.other_data.form_error_message_result.PromiseResult.success = false;
            if (this.othersPrimary_boolean) {
                this.otherreg.other_data.form_error_message_result.PromiseResult.data.push(
                    'Enter the Primary Occupation.'
                );
            }
            if (this.othersSecondary_boolean) {
                this.otherreg.other_data.form_error_message_result.PromiseResult.data.push(
                    'Enter the Secondary Occupation.'
                );
            }
        }
        if (!this.otherreg.other_data.form_error_message_result.PromiseResult.success) {
            this.otherreg.other_data.reg_api_result.Posting = false;
        } else if (this.otherreg.other_data.form_error_message_result.PromiseResult.success) {
            await this.uploadData();
        }
    }

    async uploadData() {
        this.otherreg.other_data.form_data = new Form_Data();
        this.otherreg.other_data.form_data.form_data = this.otherreg.other_data.form_data.create_form_data(this.otherreg.api_data, new FormData(), "");
        //   if (Boolean(this.otherreg.other_data.email)) {
        //         this.otherreg.other_data.form_data.form_data.append("d_email", this.otherreg.other_data.email);
        //     }
        await this.otherMedicalRegistrationService
            .createOtherMedicalReferrals(this.otherreg.other_data.form_data.form_data)
            .toPromise()
            .then((result) => {
                this.otherreg.other_data.reg_api_result.PromiseResult = result;
                // this.profile_data_result = this.response.success;
                if (result.success) {
                    this.otherreg.api_data.guid.user_guid = result.data.user_guid;
                    this.otherreg.api_data.guid.current_user_guid =
                        result.data.user_guid;
                    this.set_data(result);
                    this.otherreg.other_data.tabViewData.nextTab(1);
                }
                this.otherreg.other_data.reg_api_result.Posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.otherreg.other_data.reg_api_result.ServerError = error.error;
                this.otherreg.other_data.reg_api_result.PromiseResult.success = false;
                this.otherreg.other_data.reg_api_result.Posting = false;

            });

        // if (
        //     this.profile_data_result != null &&
        //     this.profile_data_result == false
        // ) {
        //     this.otherreg.other_data.formData_apiResult.Posting = false;

        //     return;
        // }
        // if (this.profilePhoto != null) {
        //     let formPhoto: FormData = new FormData();
        //     formPhoto.set(
        //         'current_user_guid',
        //         this.otherreg.api_data.guid.current_user_guid
        //     );
        //     formPhoto.set('file', this.profilePhoto);

        //     await this.otherMedicalRegistrationService
        //         .OtherMedicalUploadProfilePhoto(
        //             formPhoto,
        //             this.otherreg.api_data.guid.user_guid
        //         )
        //         .toPromise()
        //         .then((result) => {
        //             this.response = result;
        //             if (this.response.success) {
        //                 this.profile_photo_result = this.response.success;
        //                 // this.otherreg.user_guid = result.data.user_guid;
        //             }
        //         })
        //         .catch((error: HttpErrorResponse) => {
        //             this.serverError = error.error;
        //             this.response.success = false;
        //             this.otherreg.other_data.formData_apiResult.Posting = false;

        //         });

        //     if (
        //         this.profile_photo_result != null &&
        //         this.profile_photo_result == false
        //     ) {
        //         this.otherreg.other_data.formData_apiResult.Posting = false;

        //         return;
        //     }
        // }

        // if (this.resume != null) {
        //     let formResume: FormData = new FormData();
        //     formResume.set(
        //         'current_user_guid',
        //         this.otherreg.api_data.guid.current_user_guid
        //     );
        //     formResume.set('file', this.resume);

        //     await this.otherMedicalRegistrationService
        //         .OtherMedicalUploadResume(
        //             formResume,
        //             this.otherreg.api_data.guid.user_guid
        //         )
        //         .toPromise()
        //         .then((result) => {
        //             this.response = result;
        //             if (this.response.success) {
        //                 this.resume_result = this.response.success;
        //                 // this.otherreg.user_guid = result.data.user_guid;
        //             } else {
        //             }
        //         })
        //         .catch((error: HttpErrorResponse) => {
        //             this.serverError = error.error;
        //             this.response.success = false;
        //             this.otherreg.other_data.formData_apiResult.Posting = false;

        //         });

        //     if (this.resume_result != null && this.resume_result == false) {
        //         this.otherreg.other_data.formData_apiResult.Posting = false;

        //         return;
        //     }
        // }

        // if (
        //     this.profile_data_result ||
        //     this.profile_photo_result ||
        //     this.resume_result
        // ) {
        //     // if ((this.updateDataResult || this.sig_result || this.profile_result || this.resume_result) && !(this.posting)) {
        //     // if (a && !(this.posting)) {
        //     this.showForm = false;
        //     // this.success_register_display = true;
        //     // this.showDialog();
        //     this.utilitiesService.RouterNavigation('/user/thank-you/' + this.user_types['OTHER-MEDICAL-PROFESSIONALS']);
        // }
    }

    async submitDoctorRegistration() {
        let waitSec = Number((Math.floor(Math.random() * 1000) + 1) % 3);
        this.otherreg.other_data.reg_api_result = new ApiResult(true);
        this.otherreg.other_data.recaptchaData.reset();
        setTimeout(async () => {
            await this.submitData();
        }, 5000 + waitSec);
    }

    async RestoreData() {
        // if (JSON.parse(localStorage.getItem("Referral")) == null) {
        //   this.masterChecker = false;
        // }
        // else if (JSON.parse(localStorage.getItem("Referral")) != null) {
        //   await this.NullChecker();
        // }
        // if (this.masterChecker) {
        //   // if (event.defaultPrevented) return;
        //   // event.preventDefault();
        //   await this.confirmationService.confirm({
        //     key: 'confirm-local-data',
        //     message: 'Are you sure you want to restore previous filled data?',
        //     icon: 'pi pi-exclamation-triangle',
        //     accept: async () => {
        //       await this.getLocalProfileData();
        //     },
        //   });
        // }
    }
}
